import React from "react";

import { IgCheckbox, IgTypography } from "@intelligems/ig-theme";
import { ProgressBarStyles } from "@intelligems/ig-types";
import { FormControlLabel, Grid } from "@mui/material";

import { OfferStyleSlider } from "./components/OfferStyleSlider";

interface BarAndBreakpointSectionProps {
  bar: ProgressBarStyles["bar"];
  breakpoint: ProgressBarStyles["breakpoint"];
  onChange: (
    section: "bar" | "breakpoint",
    property: string,
    value: number | boolean
  ) => void;
  showBreakpointOptions?: boolean;
  disabled?: boolean;
}

export const BarAndBreakpointSection = ({
  bar,
  breakpoint,
  onChange,
  showBreakpointOptions,
  disabled,
}: BarAndBreakpointSectionProps) => {
  return (
    <Grid item container direction="column" spacing={3}>
      <Grid item>
        <IgTypography fontWeight="600" variant={"body1"}>
          Bar
        </IgTypography>
      </Grid>
      <Grid item container spacing={7}>
        <OfferStyleSlider
          label="Thickness"
          value={bar.thickness}
          onChange={(value) => onChange("bar", "thickness", value)}
          min={0}
          max={40}
          xs={3}
          disabled={disabled}
        />
        <OfferStyleSlider
          label="Corner radius"
          value={bar.cornerRadius}
          onChange={(value) => onChange("bar", "cornerRadius", value)}
          min={0}
          max={20}
          xs={3}
          disabled={disabled}
        />
      </Grid>
      {showBreakpointOptions && (
        <>
          <Grid item>
            <IgTypography fontWeight="600" variant={"body1"}>
              Breakpoint
            </IgTypography>
          </Grid>
          <Grid item container spacing={7}>
            <OfferStyleSlider
              label="Icon size"
              value={breakpoint.iconSize}
              onChange={(value) => onChange("breakpoint", "iconSize", value)}
              min={0}
              max={20}
              xs={3}
              disabled={disabled}
            />
            <OfferStyleSlider
              label="Dot size"
              value={breakpoint.size}
              onChange={(value) => onChange("breakpoint", "size", value)}
              min={0}
              max={40}
              xs={3}
              disabled={disabled}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              disabled={disabled}
              control={
                <IgCheckbox
                  disabled={disabled}
                  checked={breakpoint.hideText}
                  onChange={() =>
                    onChange("breakpoint", "hideText", !breakpoint.hideText)
                  }
                  size="small"
                />
              }
              label={
                <IgTypography variant={"body1"}>
                  Hide breakpoint text
                </IgTypography>
              }
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
